<div>
    <hb-header [headline]="'1. Metrics'" [data]="headerList" (chosenPath)="choice = $event"></hb-header>

    <div [style.visibility]="(choice == 'AnnualQuarterly') ? 'visible' : 'hidden'">
        <annual-quarterly></annual-quarterly>
    </div>
</div>